"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_64_2_0 = void 0;
/**
 * Migrate to 64.2.0
 *
 * add hasNoRinne
 */
const migration_64_2_0 = (json) => {
    if (json.HasNoRinne === undefined) {
        if (json.Fuehrungsrinnen && json.Fuehrungsrinnen.length === 0) {
            json.HasNoRinne = true;
        }
        else if (json.Fuehrungsrinnen && json.Fuehrungsrinnen.length > 0) {
            json.HasNoRinne = false;
        }
    }
    return json;
};
exports.migration_64_2_0 = migration_64_2_0;
//# sourceMappingURL=migration_64_2_0.js.map